module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('home-join-banner'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('home-join-navi'), _vm._v(" "), _c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ff4640ca!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/join_us/HomeJoinUs.vue
// module id = 176
// module chunks = 1